// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export var Language;
(function (Language) {
    Language["LANGUAGE_UNSPECIFIED"] = "LANGUAGE_UNSPECIFIED";
    Language["LANGUAGE_EN_US"] = "LANGUAGE_EN_US";
    Language["LANGUAGE_ES_US"] = "LANGUAGE_ES_US";
})(Language || (Language = {}));
export var Language_index;
(function (Language_index) {
    Language_index[Language_index["LANGUAGE_UNSPECIFIED"] = 0] = "LANGUAGE_UNSPECIFIED";
    Language_index[Language_index["LANGUAGE_EN_US"] = 1] = "LANGUAGE_EN_US";
    Language_index[Language_index["LANGUAGE_ES_US"] = 2] = "LANGUAGE_ES_US";
})(Language_index || (Language_index = {}));
export var Gender;
(function (Gender) {
    Gender["GENDER_UNSPECIFIED"] = "GENDER_UNSPECIFIED";
    Gender["GENDER_MALE"] = "GENDER_MALE";
    Gender["GENDER_FEMALE"] = "GENDER_FEMALE";
})(Gender || (Gender = {}));
export var Gender_index;
(function (Gender_index) {
    Gender_index[Gender_index["GENDER_UNSPECIFIED"] = 0] = "GENDER_UNSPECIFIED";
    Gender_index[Gender_index["GENDER_MALE"] = 1] = "GENDER_MALE";
    Gender_index[Gender_index["GENDER_FEMALE"] = 2] = "GENDER_FEMALE";
})(Gender_index || (Gender_index = {}));
/**
 * AudioLibraryService provides endpoints for managig audio files. This is rebrand from Media and MediaFile.
 * NWX Endpoints. Location-id is not used.
 */
export const AudioLibraryService = {
    /**
     * List audio files by tenant
     */
    List(fn, req) {
        return fn(`/phone/audio-library/v1?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Delete the audio library.
     */
    Delete(fn, req) {
        try {
            fm.validateUrlParam(req["mediaItemId"], "mediaItemId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/audio-library/v1/${req["mediaItemId"]}?${fm.renderURLSearchParams(req, ["mediaItemId"])}`, { method: "DELETE" });
    },
    /**
     * Rename the audio file.
     */
    Rename(fn, req) {
        try {
            fm.validateUrlParam(req["mediaItemId"], "mediaItemId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/audio-library/v1/${req["mediaItemId"]}/rename`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Usage shows where the audio library is being used.
     */
    Usage(fn, req) {
        try {
            fm.validateUrlParam(req["mediaItemId"], "mediaItemId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/audio-library/v1/${req["mediaItemId"]}/usage?${fm.renderURLSearchParams(req, ["mediaItemId"])}`, { method: "GET" });
    },
    /**
     * TTSLanguages returns two languages: English (en-US) and Spanish (es-US)
     */
    TTSLanguages(fn, req) {
        return fn(`/phone/audio-library/v1/tts/languages?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * TTSVoices returns a list of available voices based on the selected language
     */
    TTSVoices(fn, req) {
        return fn(`/phone/audio-library/v1/tts/voices`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
